import { v4 as uuidv4 } from "uuid";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import { emailValidation } from "./validations";
import { postRequest } from "./api";
import moment from "moment-jalaali";
import fa from "moment/locale/fa";
moment.locale("fa", fa);
moment.loadPersian({ dialect: "persian-modern" });
Swiper.use([Navigation, Pagination, Autoplay]);

const RootLayoutDataModel = window.RootLayoutData;

// show alert function

export const showAlert = (messages, position = "#js-fixed-alert-wrapper") => {
  for (let messageItem in messages) {
    let tmpMessage = [messageItem, messages[messageItem]];

    let boxClass = "";
    let iconClass = "";

    if (tmpMessage && tmpMessage[1] && tmpMessage[1].message) {
      let message = tmpMessage[1].message;
      let status = parseInt(tmpMessage[1].type);

      if (!message) {
        message = tmpMessage[0];
        status = parseInt(tmpMessage[1]);
      }

      switch (status) {
        case 1: {
          // Success
          boxClass = "alert--success";
          iconClass = "icon-check-circle-fill";
          break;
        }

        case 8: {
          // Error
          boxClass = "alert--danger";
          iconClass = "icon-warning-circle";
          break;
        }

        case 4: {
          // Warning
          boxClass = "alert--warning";
          iconClass = "icon-warning";
          break;
        }

        case 2: {
          // Info
          boxClass = "alert--info";
          iconClass = "icon-info-circle";
          break;
        }
      }

      let para = document.createElement("div");
      let paraText = document.createElement("div");
      let paraIcon = document.createElement("i");
      let paraBtn = document.createElement("button");
      let node = document.createTextNode(message);

      paraIcon.classList.add("alert__icon", iconClass);

      paraBtn.classList.add("alert__close", "icon-close");

      paraText.appendChild(node);
      para.appendChild(paraIcon);
      para.appendChild(paraText);

      para.appendChild(paraBtn);

      para.classList.add("alert", boxClass);

      let alertId = "js-message-" + uuidv4();

      para.setAttribute("id", alertId);

      paraBtn.onclick = function () {
        document.getElementById(alertId).remove();
      };

      let element = document.querySelector(position);

      element.appendChild(para);

      let timeOut = setTimeout(function () {
        if (document.getElementById(alertId) !== null) {
          document.getElementById(alertId).style.height = 0;
          document.getElementById(alertId).remove();
          clearTimeout(timeOut);
        }
      }, 8000);
    }
  }
};

// Array.from(document.querySelectorAll(".alert")).forEach(function (
//   item
// ) {
//   item
//     .querySelector(".js-alert-close")
//     .addEventListener("click", function () {
//       let alertItem = this.closest(".alert");
//       alertItem.parentNode.removeChild(alertItem);

//     });
// });

// convert Fa to En number
export const convertFaToEnNumber = (text) => {
  text = String(text);

  return text.replace(/[۰-۹]/g, function (chr) {
    let persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

    return persian.indexOf(chr);
  });
};

// reading time convert
export const convertReadTime = (time, type, item) => {
  if (type === "1") {
    if (time.getMinutes() >= 1) {
      item.innerText = time.getMinutes() + " دقیقه ";
    } else {
      item.innerText = time.getSeconds() + " ثانیه ";
    }
  } else if (type === "2") {
    if (time.getMinutes() >= 1) {
      item.innerText = "زمان مطالعه: " + time.getMinutes() + " دقیقه ";
    } else {
      item.innerText = "زمان مطالعه: " + time.getSeconds() + " ثانیه ";
    }
  } else if (type === "3") {
    if (time.getMinutes() >= 1) {
      item.innerText = "مطالعه: " + time.getMinutes() + " دقیقه ";
    } else {
      item.innerText = "مطالعه: " + time.getSeconds() + " ثانیه ";
    }
  }
};

// pick image url
export const pickImageUrl = (url, width, height) => {
  let extension = "." + url.split(".").pop();

  return url.replace(extension, "") + "-" + width + "x" + height + extension;
};

// trim text
export const trimText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  } else {
    return text;
  }
};

// create slider
export const createSlider = ({
  selector,
  slidesPerView = 3,
  spaceBetweenInMobile,
  spaceBetweenInDesktop,
  loop = false,
  pagination = ".js-slider-pagination",
  customOptions,
}) => {
  
  if(document.querySelectorAll(selector).length){
    Array.from(document.querySelectorAll(selector)).forEach((item) => {
      
      let sliderSelector = `js-slider-${uuidv4()}`;
  
      item.classList.add(sliderSelector);
  
      new Swiper(`.${sliderSelector}`, {
        init: true,
        slidesPerView,
        spaceBetween: spaceBetweenInMobile,
        loop: loop,
        loopedSlides: 0,
        autoplay: false,
        observer: true,
        observeParents: true,
        ...customOptions,
        pagination: {
          el: pagination,
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          992: {
            spaceBetween: spaceBetweenInDesktop,
          },
  
          320: {
            slidesPerView: "auto",
            spaceBetween: spaceBetweenInMobile,
          },
        },
      });
    });
  }
};

// format price
export const formatPrice = (price) => {
  if (!price) return 0;

  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// submit footer newsletter form
export const submitNewsletter = (input, btn) => {
  let email = input.value;

  if (!email) {
    showAlert([
      {
        type: 4,
        message: "ورود ایمیل الزامی است",
      },
    ]);

    input.classList.add("error");

    return;
  } else if (!emailValidation(email)) {
    showAlert([
      {
        type: 4,
        message: "ایمیل وارد شده صحیح نمی باشد",
      },
    ]);

    input.classList.add("error");

    return;
  } else {
    input.classList.add("remove");

    input.setAttribute("disabled", true);

    let payload = {
      url: RootLayoutDataModel.urls.newsLetter,
      data: { email },
    };

    postRequest(payload).then(() => {
      input.removeAttribute("disabled");

      btn.classList.remove("is-loading");

      input.value = "";
    });
  }
};

export const dateFormat = (date, format = "jYYYY/jMM/jDD", locale = "fa") => {
  return moment(date).locale(locale).format(format);
};

// format persian date to georation date
export const formatDateToEn = (date) => {
  return moment(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD");
};
